import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const [s, srv] = await Promise.all([
        api.get("/site/settings"),
        api.get("/services"),
      ]);
      setSettings(s.data || {});
      setServices(srv.data || []);
    } catch (e) {
      // Don't crash the whole app on transient errors
      console.error("Failed to load site content", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SiteContext.Provider value={{ settings, services, loading, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext) || { settings: null, services: [], loading: true };
}
